import { PersistencePort } from '@/data/ports/PersistencePort';
import { DataSnapshot } from '@/types/domain';

const KEY = 'legaltech.snapshot';

export const LocalStorageAdapter: PersistencePort = {
  name: 'local',
  async health() {
    try {
      localStorage.setItem('__t', '1');
      localStorage.removeItem('__t');
      return { ok: true };
    } catch (e: any) {
      return { ok: false, details: String(e) };
    }
  },
  async get() {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as DataSnapshot) : null;
  },
  async put(data) {
    localStorage.setItem(KEY, JSON.stringify(data));
  },
  async clear() {
    localStorage.removeItem(KEY);
  },
};
